<script>
    import FormWrapper from './FormWrapper';
    export default {
        mixins: [FormWrapper],
        props: {
            url: {
                type: String,
                required: false
            },
            behaviourBag: {
                type: String,
                required: false
            },
            showEvent: {
                type: String,
                required: false
            },
            fireEvent: {
                type: String,
                required: true
            },
            hideEvent: {
                type: String,
                required: false
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                is_visible: this.visible
            }
        },
        created() {
            if (this.showEvent) {
                window.EventHandler.listen(this.showEvent, () => {
                    this.stopProcessing();
                    this.is_visible = true;
                });
            }
            if (this.hideEvent) {
                window.EventHandler.listen(this.hideEvent, () => {
                    this.is_visible = false;
                    this.stopProcessing();
                });
            }
        },
        methods: {
            submit() {
                this.errors.clear();
                if (!this.validator.passes()) {
                    window.EventHandler.fire('top-warning', {
                        id: 1,
                        message: 'The given data was invalid.'
                    });
                    this.stopProcessing();
                    return;
                }
                this.startProcessing();
                this.saveData();
                window.EventHandler.fire(this.fireEvent);
            }
        }
    }
</script>